import { isRTLLocale } from '@wix/cashier-common/dist/src/utils/isRTLLocale';
import { createCurrencyFormatterWithDefaults } from '@wix/l10n';

interface GetShippingOptionLabelParams {
  label: string;
  amount: string;
  currencyCode: string;
  locale: string;
}

export const getShippingOptionLabel = ({ label, amount, currencyCode, locale }: GetShippingOptionLabelParams) => {
  const createCurrencyFormatter = createCurrencyFormatterWithDefaults({
    language: locale,
  });
  const formatCurrency = createCurrencyFormatter();

  const price = formatCurrency({ value: amount, currency: currencyCode });

  if (isRTLLocale(locale)) {
    return `${price} - ${label}`;
  }

  return `${label} - ${price}`;
};
